import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/multilevel_menu_example',
  component: Layout,
  name: 'multilevelMenuExample',
  meta: {
    title: '多级功能',
    icon: 'ep:document',
    code: '0101',
  },
  children: [
    {
      path: 'page',
      name: 'multilevelMenuExample1',
      component: () => import('@/views/index.vue'),
      meta: {
        title: '一级功能',
        code: '010101',
      },
    },
    {
      path: 'level2',
      name: 'multilevelMenuExample2',
      meta: {
        title: '个性功能',
        popover: true,
        code: '010102',
      },
      children: [
        {
          path: 'page',
          name: 'multilevelMenuExample2-1',
          component: () => import('@/views/index.vue'),
          meta: {
            title: '导航2-1',
            code: '01010201',
          },
        },
      ],
    },
  ],
}

export default routes
